import { render, staticRenderFns } from "./g-d-vajra.vue?vue&type=template&id=a39c5c42&scoped=true"
import script from "./g-d-vajra.vue?vue&type=script&lang=js"
export * from "./g-d-vajra.vue?vue&type=script&lang=js"
import style0 from "./g-d-vajra.vue?vue&type=style&index=0&id=a39c5c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39c5c42",
  null
  
)

export default component.exports